const Redirect = require('./redirect');

const ACCESS_TOKEN_KEY = 'access-token';
const REFRESH_TOKEN_KEY = 'refresh-token';
const JIVO_TOKEN_KEY = 'jivo-token';
const DEFAULT_PAGE = '/';
const LOGIN_PAGE = '/login';
const CALC_PAGE = '/calc';
const CALC2_PAGE = '/calc2';
const TRACKING_PAGE = '/tracking';

function isOnPage(page) {
    var curPage = Redirect.getCurrentUrl();
    var argsStartIndex = curPage.indexOf('?');
    if (argsStartIndex > 0) {
        curPage = curPage.substr(0, argsStartIndex);
    }
    while (curPage.endsWith('/')) {
        curPage = curPage.substr(0, curPage.length - 1);
    }
    return curPage.endsWith(page);
}

function isOnLoginPage() {
    return isOnPage(LOGIN_PAGE);
}

function isOnCalcPage() {
    return isOnPage(CALC_PAGE) || isOnPage(CALC2_PAGE);
}

function isOnTrackingPage() {
    return isOnPage(TRACKING_PAGE);
}

function isAnonymousAllowed() {
    return isOnLoginPage() || isOnCalcPage() || isOnTrackingPage();
}

function getSessionAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
}

function getSessionRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
}

function getSessionJivoToken() {
    return localStorage.getItem(JIVO_TOKEN_KEY);
}

function restoreSession(accessToken, refreshToken, needRedirect, jivoToken) {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    localStorage.setItem(JIVO_TOKEN_KEY, jivoToken);
    if (needRedirect) {
        Redirect.redirect(DEFAULT_PAGE);
    }
}

function stopSession() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(JIVO_TOKEN_KEY);
    window.jivo_api && window.jivo_api.clearHistory();
    Redirect.redirect(LOGIN_PAGE);
}

module.exports = {
    isOnLoginPage: isOnLoginPage,
    isAnonymousAllowed: isAnonymousAllowed,
    getSessionAccessToken: getSessionAccessToken,
    getSessionRefreshToken: getSessionRefreshToken,
    getSessionJivoToken: getSessionJivoToken,
    restoreSession: restoreSession,
    stopSession: stopSession
};


// WEBPACK FOOTER //
// ./App/services/session.js